import { render, staticRenderFns } from "./studentCard.vue?vue&type=template&id=b588f268&scoped=true&"
import script from "./studentCard.vue?vue&type=script&lang=js&"
export * from "./studentCard.vue?vue&type=script&lang=js&"
import style0 from "./studentCard.vue?vue&type=style&index=0&id=b588f268&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b588f268",
  null
  
)

export default component.exports